export enum LoginStatus {
    Success = 0,
    Failed = 1,
    Lockout = 2,
    NeedsConfirmation = 3
}
